module.exports = __webpack_public_path__ + "img/chat_top.e6540696.png";